<template>
  <div class="box">
    <h2>Advisory Board</h2>

    <div class="row">
      <div
        class="col-6 col-md-4 col-lg"
        v-for="advisor in advisors"
        :key="advisor.uuid"
      >
        <div class="box-inner tile-advisor">
          <router-link :to="`/user/${advisor.advisor.uuid}`">
            <img
              class="img-profile img-fluid rounded-circle mb-16"
              :src="advisor.advisor.avatar"
            />
          </router-link>

          <h5 class="mb-8">
            <router-link :to="`/user/${advisor.advisor.uuid}`">
              {{ advisor.advisor.first_name }} {{ advisor.advisor.last_name }}
            </router-link>
          </h5>

          <ul class="list-inline mb-16">
            <li
              class="list-inline-item"
              v-for="expertise in advisor.advisor.expertise.filter((el) => el)"
              :key="expertise.skill_id"
            >
              <b-badge variant="light">
                {{ expertise.title.split(' ')[0] }}
              </b-badge>
            </li>
          </ul>

          <b-btn
            variant="primary"
            size="sm"
            block
            @click="openModal(advisor.advisor)"
            v-if="advisor.status === 'approved'"
          >
            Book Meeting
          </b-btn>

          <b-btn
            variant="primary"
            size="sm"
            block
            disabled
            v-if="advisor.status === 'pending'"
          >
            Pending
          </b-btn>
        </div>
      </div>

      <div class="col-6 col-md-4 col-lg" v-if="advisors.length < 5">
        <div class="box-inner tile-advisor">
          <div class="bg-primary img-profile rounded-circle mb-16 mx-auto" />

          <h5 class="mb-8">TBD</h5>

          <ul class="list-inline mb-16">
            <li class="list-inline-item">
              <b-badge variant="light">Role</b-badge>
            </li>
          </ul>

          <b-btn variant="primary" size="sm" block to="/advisors">
            Add Advisor
          </b-btn>
        </div>
      </div>
    </div>

    <schedule-modal
      :show="showScheduleModal"
      :user="user"
      @dismiss="showScheduleModal = false"
    />
  </div>
</template>

<script>
import ScheduleModal from '@/components/advisors/ScheduleModal'

export default {
  name: 'AdvisoryBoard',
  components: {
    ScheduleModal,
  },
  data() {
    return {
      loading: false,
      advisors: [],
      user: null,
      showScheduleModal: false,
      areas: {
        finance: 'Finance',
        legal: 'Legal',
        hr: 'HR',
        strategy: 'Strategy',
        ops: 'Ops',
        tech: 'Tech',
        sales: 'Mktg/Sales',
        buySell: 'Buy/Sell',
        franchising: 'Franch',
        international: 'Intl',
        government: 'Govt',
      },
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.loading = true

      this.$http
        .get('advisory_board')
        .then(
          (res) => {
            this.advisors = res.data.data
          },
          () => {}
        )
        .finally(() => {
          this.loading = false
        })
    },
    openModal(user) {
      this.user = user
      this.showScheduleModal = true
    },
  },
}
</script>

<style scoped>
.img-profile {
  width: 96px;
  height: 96px;
}
</style>
